import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ToastPosition } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [CommonModule, TranslateModule, MatIconModule],
})
export class ToastComponent implements OnInit {
  @Input() message = '';
  @Input() title = '';
  @Input() type: 'success' | 'error' | 'warning' | 'info' = 'info';
  @Input() duration = 5000;
  @Input() showCloseButton = false;
  @Input() position?: ToastPosition;

  @Output() closed = new EventEmitter<void>();

  get hasTitle(): boolean {
    return this.title.trim().length > 0;
  }

  ngOnInit() {
    if (this.duration > 0) {
      setTimeout(() => this.close(), this.duration);
    }
  }

  close() {
    this.closed.emit();
  }

  get icon() {
    switch (this.type) {
      case 'success': return 'check_circle';
      case 'error': return 'error';
      case 'warning': return 'warning';
      case 'info': return 'info';
      default: return '';
    }
  }

  isTranslationKey(msg: string): boolean {
    return msg.includes('.') || msg.startsWith('LESSONS');
  }
}
